import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class AdShareByEmailUserService extends Service {
  constructor({config, repository}) {
    super()
    this._config = config
    this._httpUserRepository = repository
  }
  /**
   * @method
   * @return {Promise}
   */

  @inlineError
  async execute({adId, contractId, email}) {
    const [error, response] = await this._httpUserRepository.adShareByEmail({
      adId,
      contractId,
      email
    })

    if (error || !response) return Promise.reject(error)
    return Promise.resolve(true)
  }
}
